import { literal, object, union } from 'superstruct';
export const DUPLICATE_ROLE_NAME = 'validations:Duplicate Role Name';
export const AddEditRoleErrorDto = union([object({
  message: literal(DUPLICATE_ROLE_NAME)
})]);